import { render, staticRenderFns } from "./ArticleComoCriarUtm.vue?vue&type=template&id=03adc4f8&"
import script from "./ArticleComoCriarUtm.vue?vue&type=script&lang=js&"
export * from "./ArticleComoCriarUtm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports